var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.commitBool,
          expression: "commitBool"
        }
      ],
      staticClass: "edit-collect-dialog"
    },
    [
      _c(
        "div",
        { staticClass: "dialog-body" },
        [
          _c(
            "el-form",
            {
              ref: "collectItem",
              attrs: {
                "label-position": "top",
                model: _vm.collectItem,
                rules: _vm.rules,
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "收藏夹标题", prop: "favoriteName" } },
                [
                  _c("el-input", {
                    attrs: {
                      id: "newCollectTitle",
                      size: "small",
                      placeholder: "请输入收藏夹标题"
                    },
                    model: {
                      value: _vm.collectItem.favoriteName,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.collectItem,
                          "favoriteName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "collectItem.favoriteName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "收藏描述", prop: "favoriteDesc" } },
                [
                  _c("el-input", {
                    attrs: {
                      id: "newCollectDesc",
                      size: "small",
                      rows: "3",
                      maxlength: "500",
                      "show-word-limit": "",
                      type: "textarea",
                      placeholder: "请输入收藏描述"
                    },
                    model: {
                      value: _vm.collectItem.favoriteDesc,
                      callback: function($$v) {
                        _vm.$set(_vm.collectItem, "favoriteDesc", $$v)
                      },
                      expression: "collectItem.favoriteDesc"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "dialog-footer" }, [
        _c("input", {
          staticClass: "btn",
          staticStyle: { width: "68px" },
          attrs: { type: "button", value: "取消" },
          on: { click: _vm.cancelDailog }
        }),
        _c("input", {
          staticClass: "btn btn-red",
          staticStyle: { width: "68px" },
          attrs: { type: "button", value: "确认" },
          on: {
            click: function($event) {
              return _vm.commit("collectItem")
            }
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }